import React from 'react'
import { BreadCrumb, BreadCrumbItem } from '../components/Breacrcrumb/Breadcrumb'
import ClientsSlider from '../components/ClientsSlider/ClientsSlider'
import { SectionTitle } from '../components/SectionTitle/SectionTitle'
import ServicesComponent from '../components/ServicesComponent/ServicesComponent'

interface ServicesProps {
    
}

const Services:React.FC<ServicesProps> = ({}) => {
    const title: string = 'IT and web solutions to help digital transformation of your company'
    const subtitle: string = 'We are a creative company that works with passion and love. We provide the best services you need. We help you become better. We pride ourselves on helping our clients achieve great results when it comes to their projects. From data to performance - we will help you.'
    return (
        <div className='Services'>
            <BreadCrumb title={"Services"}>
				<BreadCrumbItem name={"Home"} to="/" />
				<BreadCrumbItem name={"Services"} current={true} />
			</BreadCrumb>
            <SectionTitle title={title} subtitle={subtitle}/>
            <ServicesComponent />
            <ClientsSlider />
        </div>
    )
}

export default Services